import PageWrapper from './PageWrapper';

export default PageWrapper;



// WEBPACK FOOTER //
// ./src/components/Page/PageWrapper/index.tsx